import { isEmpty, uniq } from 'lodash';
import { GetListParams, GetListResult } from 'react-admin';
import { getClientApi } from 'src/data-communication';
import { mapQuoteDtoListToModel } from 'src/mappers';
import { Quote } from 'src/models';

const clientApi = getClientApi();

export const getQuoteList = async (params: Partial<GetListParams>): Promise<GetListResult<Quote>> => {
  const { symbols } = params.meta;

  const uniqueSymbols = uniq(symbols);

  if (isEmpty(uniqueSymbols)) {
    return {
      data: [],
      total: 0,
    };
  }

  const result = await clientApi.quote.list({ queryParams: { symbols: uniqueSymbols.join(',') } });

  return {
    data: mapQuoteDtoListToModel(result.data),
    total: result.data.length,
  };
};
